module.exports = __webpack_public_path__ + "img/header.92078252.jpg";